import { ChangeEvent, RefObject } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { isImageFile } from '@gem/utils';

import Tasks from 'APP/Tasks';

interface IUploadButtonPresenterParams {
  inputRef: RefObject<HTMLInputElement>;
  onSelectFile(file: File): void;
}

interface IUploadButtonPresenter {
  onClick(): void;
  onChange(event: ChangeEvent<HTMLInputElement>): void;
}

export function useUploadButtonPresenter({
  inputRef,
  onSelectFile,
}: IUploadButtonPresenterParams): IUploadButtonPresenter {
  const { t } = useTranslation();
  return {
    onClick(): void {
      inputRef.current?.click();
    },

    onChange(event: ChangeEvent<HTMLInputElement>): void {
      const file = event.target.files?.[0];
      if (!file) {
        return;
      }
      if (!isImageFile(file)) {
        Tasks.app.showToast(t('background_error'), { style: '4' });
        return;
      }
      onSelectFile(file);
      event.target.value = '';
    },
  };
}
